/* eslint-disable max-lines-per-function */
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import React, { useEffect, useRef, useState } from 'react';
import {
    IoIosCloseCircleOutline,
    IoIosCheckmarkCircleOutline,
    IoIosPrint
} from 'react-icons/io';
import MensalidadeService from '../../services/mensalidades/mensalidadeService';
import './tabela-cobranca.css';
import { showMessageError } from '../others/toastr';
import { ProgressSpinner } from 'primereact/progressspinner';
import DialogOpcoesPagamento from '../dialogs/dialog-opcoes-pagamento';
import DialogPdf from '../dialogs/dialog-pdf';
import {
    formatDataEUA,
    gerarUrlBoleto
} from '../../modulos/mensalidade/utilsBoletoAdyen';
import DialogPix from '../dialogs/dialog-pix';
import { Messages } from 'primereact/messages';
import DialogDropinAdyen from '../dialogs/dialog-dropin-adyen';
import DialogSuccessPagamentoCartao from '../dialogs/dialog-pagamento-cartao';
import LogsParamentosService from '../../services/logs/logsPagamentosService';
import { decriptObjectOnLocalStorage } from '../../modulos/cripotografia/criptoStorage';

export default function TabelaCobrancaAssociado({ inscricao }) {
    const dt = useRef(null);
    const messages = useRef(null);

    const [dadosTabela, setDadosTabela] = useState([]);
    const [faturas, setFaturas] = useState([]);
    const [faturasNaoPagas, setFaturasNaoPagas] = useState([]);
    const [selectedFaturas, setSelectedFaturas] = useState([]);
    const [faturaParaImpressao, setFaturaParaImpressao] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [desabilitarPagamento, setDesabilitarPagamento] = useState(true);
    const [habilitarNaoPagos, setHabilitarNaoPagos] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loadingTabela, setLoadingTabela] = useState(false);
    const [openDialogPagamento, setOpenDialogPagamento] = useState(false);
    const [openDialogBoleto, setOpenDialogBoleto] = useState(false);
    const [openDialogPix, setOpenDialogPix] = useState(false);
    const [pagamentoSuccess, setPagamentoSuccess] = useState(false);
    const [openDialogPagamentoCartao, setOpenDialogPagamentoCartao] = useState(false);
    const [metodoPagamento, setMetodoPagamento] = useState(null);
    const [urlPdf, setUrlPdf] = useState(null);
    const [urlBoleto, setUrlBoleto] = useState(null);
    const [loadingBoleto, setLoadingBoleto] = useState(false);
    const [boletoGerado, setBoletoGerado] = useState(false);

    const idUsuarioLogado = decriptObjectOnLocalStorage('IDuser');

    useEffect(() => {
        (async () => {
            try {
                let mensalidades =
                    await MensalidadeService.buscaMensalidadesPorInscricao(inscricao);

                mensalidades = ordenarFaturas(mensalidades);
                mensalidades = ordenarFaturasNaoPagas(mensalidades);
                loadFaturasnaoPagas(mensalidades);
                setFaturas(mensalidades);
                setDadosTabela(mensalidades);
                setLoading(false);
            } catch (err) {
                showMessageError(
                    'Erro de conexão com o servidor',
                    'Tente novamente mais tarde'
                );
                setLoading(false);
            }
        })();

        const loadFaturasnaoPagas = mensalidades => {
            let mensalidadesNaoPagas = mensalidades.filter(
                fatura => fatura.Pagamento === null
            );

            mensalidadesNaoPagas = ordenarFaturas(mensalidadesNaoPagas);
            setFaturasNaoPagas(mensalidadesNaoPagas);
        };

        const ordenarFaturasNaoPagas = mensalidades => {
            let posicaoNaoPaga = 0;
            const mensalidadesNaoPagasOrdenadas = mensalidades.map(fatura => {
                if (!fatura.Pagamento) {
                    return {
                        ...fatura,
                        ordem: posicaoNaoPaga++
                    };
                } else {
                    return fatura;
                }
            });

            return mensalidadesNaoPagasOrdenadas;
        };
    }, []);

    useEffect(() => {
        if (selectedFaturas.length === 0) {
            clearMessages();
            setDesabilitarPagamento(true);

            return;
        }

        const faturasPagas = selectedFaturas.filter(
            fatura => fatura.Pagamento !== null
        );

        if (faturasPagas.length > 0) {
            setDesabilitarPagamento(true);

            return;
        }

        // !Chamada Anterior para a função checa gap
        const existeGap = checarGap();

        if (existeGap) {
            if (messages.current.state.messages.length === 0) {
                showWarnMessage('As faturas devem ser pagas na ordem do vencimento.');
            }

            setDesabilitarPagamento(true);

            return;
        }

        clearMessages();
        setDesabilitarPagamento(false);
    }, [selectedFaturas]);

    useEffect(() => {
        const changeMetodoPagamento = async () => {
            switch (metodoPagamento) {
                case 'Boleto':
                    await abrirBoleto(selectedFaturas);
                    break;
                case 'Pix':
                    setOpenDialogPix(true);
                    break;
                case 'Cartão de Crédito':
                    setOpenDialogPagamentoCartao(true);
                    break;
            }
        };

        if (!openDialogPagamento) {
            changeMetodoPagamento();
            geraLogPagamento();
        }
    }, [openDialogPagamento]);

    const geraLogPagamento = async () => {
        if (metodoPagamento) {
            const { Valor, Referencia } = selectedFaturas.reduce((acumulador, {
                Valor, Referencia
            }) => {
                if (acumulador && !acumulador['Valor'] && !acumulador['Referencia']) {
                    acumulador['Valor'] = 0;
                    acumulador['Referencia'] = '';
                }

                acumulador['Valor'] += parseFloat(Valor);
                acumulador['Referencia'] += `${Referencia};`;

                return acumulador;
            }, {});

            const objetoGeraLog = {
                inscricao: parseInt(inscricao),
                valor: Valor,
                referencia: Referencia,
                tipoPagamento: metodoPagamento,
                userCreated: parseInt(idUsuarioLogado)
            };

            await LogsParamentosService.geraLogPagamento(objetoGeraLog);
        }
    };

    const ordenarFaturas = mensalidades => {
        mensalidades = mensalidades.map(mensalidade => ({
            ...mensalidade,
            VencimentoCompare: new Date(formatDataEUA(mensalidade.Vencimento))
        }));
        mensalidades = mensalidades.sort(
            (a, b) => a.VencimentoCompare - b.VencimentoCompare
        );

        return mensalidades;
    };

    //! Função que checa gap entre faturas que deixou de ser chamada temporariamente
    const checarGap = () => {
        const faturasSelecionadasOrdenadas = ordenarFaturas(selectedFaturas);

        if (faturasSelecionadasOrdenadas[0].ordem !== 0) {
            return true;
        }

        for (let i = 1; i < faturasSelecionadasOrdenadas.length; i++) {
            if (
                faturasSelecionadasOrdenadas[i].ordem -
                faturasSelecionadasOrdenadas[i - 1].ordem >
                1
            ) {
                return true;
            }
        }

        return false;
    };

    const changeNaoPagas = e => {
        setHabilitarNaoPagos(e.checked);

        if (e.checked) {
            setDadosTabela(faturasNaoPagas);
        } else {
            setDadosTabela(faturas);
        }
    };

    const selecionarFatura = e => {
        setSelectedFaturas(e.value);
    };

    const abrirBoleto = async e => {
        try {
            setLoadingTabela(true);
            setLoadingBoleto(true);
            setOpenDialogBoleto(true);

            const { readableStream, linkBoleto } = await gerarUrlBoleto(e);

            setFaturaParaImpressao(e);
            setLoadingTabela(false);

            if (!readableStream) {
                showMessageError('Erro', 'Erro ao gerar boleto, tente novamente.');
                setTimeout(() => {
                    setOpenDialogBoleto(false);
                    setLoadingBoleto(false);
                }, 1000);

                return;
            }

            const url = URL.createObjectURL(readableStream);

            setUrlBoleto(linkBoleto);
            setUrlPdf(url);

            setBoletoGerado(true);
        } catch (err) {
            setLoadingTabela(false);
            showMessageError('Erro', 'Erro de conexão com o servidor. Para gerar boleto, tente novamente.');
            setTimeout(() => {
                setOpenDialogBoleto(false);
            }, 1000);
        } finally {
            setLoadingBoleto(false);
        }
    };

    const showWarnMessage = detail => {
        messages.current.show({
            severity: 'warn',
            detail,
            sticky: true,
            closable: false
        });
    };

    const clearMessages = () => {
        if (messages.current) {
            messages.current.clear();
        }
    };

    const renderHeader = () => (
        <div className="header-tabela-cobranca">
            <Messages ref={messages} style={{ margin: '0 15px' }} />
            <div className="titulo-filtro">
                <h2>Faturas</h2>
                <div className="p-datatable-globalfilter-container">
                    <InputText
                        type="search"
                        onInput={e => setGlobalFilter(e.target.value)}
                        placeholder="Filtro Global"
                    />
                </div>
            </div>
            <div className="submenu-tabela-cobranca">
                <button
                    disabled={desabilitarPagamento}
                    onClick={() => setOpenDialogPagamento(true)}
                >
                    Pagar
                </button>
                <div className="exibir-nao-pagos">
                    <Checkbox
                        checked={habilitarNaoPagos}
                        onChange={changeNaoPagas}
                    ></Checkbox>
                    <span className="span-faturas-nao-pagas">
                        Exibir apenas faturas não pagas
                    </span>
                </div>
            </div>
        </div>
    );

    const actionBodyTemplate = rowData => (
        <div className="acoes-pagamento-cobranca">
            <button
                className="botao-acao-tabela-cobranca"
                onClick={() => abrirBoleto([rowData])}
                disabled={rowData.Pagamento}
            >
                <IoIosPrint />
                <span>Imprimir</span>
            </button>
        </div>
    );

    const pagamentoBodyTemplate = rowData => (
        <div className="status-pagamento-cobranca">
            {rowData.Pagamento ? (
                <IoIosCheckmarkCircleOutline color="green" fontSize={30} />
            ) : (
                <IoIosCloseCircleOutline color="red" fontSize={30} />
            )}
        </div>
    );

    const valorBodyTemplate = rowData => (
        <>
            {rowData.Valor === null ?
                'SEM VALOR' :
                `R$ ${rowData.Valor?.replace('.', ',')}`}
        </>
    );

    return (
        <>
            {!loading ? (
                <>
                    <div>
                        <DataTable
                            ref={dt}
                            value={dadosTabela}
                            header={renderHeader()}
                            responsive
                            className="p-datatable-customers"
                            dataKey="Referencia"
                            rowHover
                            globalFilter={globalFilter}
                            selection={selectedFaturas}
                            onSelectionChange={selecionarFatura}
                            loading={loadingTabela}
                            paginator
                            rows={10}
                            emptyMessage="Não foram encontradas cobranças"
                            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} resultados encontrados"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            rowsPerPageOptions={[10, 25, 50]}
                        >
                            <Column selectionMode="multiple" style={{ width: '3em' }} />
                            <Column
                                field="Pagamento"
                                header="Pagamento"
                                sortable
                                body={pagamentoBodyTemplate}
                            />
                            <Column field="Referencia" header="Referência" />
                            <Column field="Vencimento" header="Vencimento" />
                            <Column
                                field="Valor"
                                header="Valor"
                                sortable
                                body={valorBodyTemplate}
                            />
                            <Column
                                body={actionBodyTemplate}
                                headerStyle={{
                                    width: '8em',
                                    textAlign: 'center'
                                }}
                                bodyStyle={{
                                    textAlign: 'center',
                                    overflow: 'visible'
                                }}
                            />
                        </DataTable>
                    </div>

                    <DialogOpcoesPagamento
                        open={openDialogPagamento}
                        setOpen={setOpenDialogPagamento}
                        faturas={selectedFaturas}
                        setMetodoPagamento={setMetodoPagamento}
                    />

                    <DialogPdf
                        inscricao={inscricao}
                        open={openDialogBoleto}
                        setOpen={setOpenDialogBoleto}
                        header="Boleto"
                        pdf={urlPdf}
                        urlSemParse={urlBoleto}
                        setMetodoPagamento={setMetodoPagamento}
                        faturas={
                            selectedFaturas.length === 0 ?
                                faturaParaImpressao :
                                selectedFaturas
                        }
                        loadingBoleto={loadingBoleto}
                        boletoGerado={boletoGerado}
                    />

                    <DialogPix
                        open={openDialogPix}
                        setOpen={setOpenDialogPix}
                        header="PIX"
                        setMetodoPagamento={setMetodoPagamento}
                        inscricao={inscricao}
                        faturas={selectedFaturas}
                    />

                    <DialogDropinAdyen
                        open={openDialogPagamentoCartao}
                        setOpen={setOpenDialogPagamentoCartao}
                        header="Cartão de Crédito"
                        setMetodoPagamento={setMetodoPagamento}
                        faturas={selectedFaturas}
                        inscricao={inscricao}
                        setPagamentoSuccess={setPagamentoSuccess}
                    />

                    <DialogSuccessPagamentoCartao openDialog={pagamentoSuccess} />
                </>
            ) : (
                <ProgressSpinner />
            )}
        </>
    );
}
